export default "__VITE_ASSET__ef6ec26f__"